enum Radiusses {
  S = '2px',
  M = '4px',
  L = '8px',
  XL = '12px',
  XXL = '50%',
}

export default Radiusses;
